export default {
    "AF": {
        "name": "Afghanistan"
    },
    "EG": {
        "name": "Ägypten"
    },
    "AL": {
        "name": "Albanien"
    },
    "DZ": {
        "name": "Algerien"
    },
    "AD": {
        "name": "Andorra"
    },
    "AO": {
        "name": "Angola"
    },
    "AG": {
        "name": "Antigua und Barbuda"
    },
    "GQ": {
        "name": "Äquatorialguinea"
    },
    "AR": {
        "name": "Argentinien"
    },
    "AM": {
        "name": "Armenien"
    },
    "AZ": {
        "name": "Aserbaidschan"
    },
    "ET": {
        "name": "Äthiopien"
    },
    "AU": {
        "name": "Australien"
    },
    "BS": {
        "name": "Bahamas"
    },
    "BH": {
        "name": "Bahrain"
    },
    "BD": {
        "name": "Bangladesch"
    },
    "BB": {
        "name": "Barbados"
    },
    "BY": {
        "name": "Belarus"
    },
    "BE": {
        "name": "Belgien"
    },
    "BZ": {
        "name": "Belize"
    },
    "BJ": {
        "name": "Benin"
    },
    "BT": {
        "name": "Bhutan"
    },
    "BO": {
        "name": "Bolivien"
    },
    "BA": {
        "name": "Bosnien und Herzegowina"
    },
    "BW": {
        "name": "Botswana"
    },
    "BR": {
        "name": "Brasilien"
    },
    "BN": {
        "name": "Brunei"
    },
    "BG": {
        "name": "Bulgarien"
    },
    "BF": {
        "name": "Burkina Faso"
    },
    "BI": {
        "name": "Burundi"
    },
    "CL": {
        "name": "Chile"
    },
    "CN": {
        "name": "Volksrepublik China"
    },
    "CR": {
        "name": "Costa Rica"
    },
    "DK": {
        "name": "Dänemark"
    },
    "DE": {
        "name": "Deutschland"
    },
    "DM": {
        "name": "Dominica"
    },
    "DO": {
        "name": "Dominikanische Republik"
    },
    "DJ": {
        "name": "Dschibuti"
    },
    "EC": {
        "name": "Ecuador"
    },
    "CI": {
        "name": "Elfenbeinküste"
    },
    "SV": {
        "name": "El Salvador"
    },
    "ER": {
        "name": "Eritrea"
    },
    "EE": {
        "name": "Estland"
    },
    "SZ": {
        "name": "Eswatini"
    },
    "FJ": {
        "name": "Fidschi"
    },
    "FI": {
        "name": "Finnland"
    },
    "FR": {
        "name": "Frankreich"
    },
    "GA": {
        "name": "Gabun"
    },
    "GM": {
        "name": "Gambia"
    },
    "GE": {
        "name": "Georgien"
    },
    "GH": {
        "name": "Ghana"
    },
    "GD": {
        "name": "Grenada"
    },
    "GR": {
        "name": "Griechenland"
    },
    "GT": {
        "name": "Guatemala"
    },
    "GN": {
        "name": "Guinea"
    },
    "GW": {
        "name": "Guinea-Bissau"
    },
    "GY": {
        "name": "Guyana"
    },
    "HT": {
        "name": "Haiti"
    },
    "HN": {
        "name": "Honduras"
    },
    "IN": {
        "name": "Indien"
    },
    "ID": {
        "name": "Indonesien"
    },
    "IQ": {
        "name": "Irak"
    },
    "IR": {
        "name": "Iran"
    },
    "IE": {
        "name": "Irland"
    },
    "IS": {
        "name": "Island"
    },
    "IL": {
        "name": "Israel"
    },
    "IT": {
        "name": "Italien"
    },
    "JM": {
        "name": "Jamaika"
    },
    "JP": {
        "name": "Japan"
    },
    "YE": {
        "name": "Jemen"
    },
    "JO": {
        "name": "Jordanien"
    },
    "KH": {
        "name": "Kambodscha"
    },
    "CM": {
        "name": "Kamerun"
    },
    "CA": {
        "name": "Kanada"
    },
    "CV": {
        "name": "Kap Verde"
    },
    "KZ": {
        "name": "Kasachstan"
    },
    "QA": {
        "name": "Katar"
    },
    "KE": {
        "name": "Kenia"
    },
    "KG": {
        "name": "Kirgisistan"
    },
    "KI": {
        "name": "Kiribati"
    },
    "CO": {
        "name": "Kolumbien"
    },
    "KM": {
        "name": "Komoren"
    },
    "CD": {
        "name": "Kongo, Demokratische Republik"
    },
    "CG": {
        "name": "Kongo, Republik"
    },
    "KP": {
        "name": "Korea, Nord"
    },
    "KR": {
        "name": "Korea, Süd"
    },
    "HR": {
        "name": "Kroatien"
    },
    "CU": {
        "name": "Kuba"
    },
    "KW": {
        "name": "Kuwait"
    },
    "LA": {
        "name": "Laos"
    },
    "LS": {
        "name": "Lesotho"
    },
    "LV": {
        "name": "Lettland"
    },
    "LB": {
        "name": "Libanon"
    },
    "LR": {
        "name": "Liberia"
    },
    "LY": {
        "name": "Libyen"
    },
    "LI": {
        "name": "Liechtenstein"
    },
    "LT": {
        "name": "Litauen"
    },
    "LU": {
        "name": "Luxemburg"
    },
    "MG": {
        "name": "Madagaskar"
    },
    "MW": {
        "name": "Malawi"
    },
    "MY": {
        "name": "Malaysia"
    },
    "MV": {
        "name": "Malediven"
    },
    "ML": {
        "name": "Mali"
    },
    "MT": {
        "name": "Malta"
    },
    "MA": {
        "name": "Marokko"
    },
    "MH": {
        "name": "Marshallinseln"
    },
    "MR": {
        "name": "Mauretanien"
    },
    "MU": {
        "name": "Mauritius"
    },
    "MX": {
        "name": "Mexiko"
    },
    "FM": {
        "name": "Mikronesien"
    },
    "MD": {
        "name": "Moldau"
    },
    "MC": {
        "name": "Monaco"
    },
    "MN": {
        "name": "Mongolei"
    },
    "ME": {
        "name": "Montenegro"
    },
    "MZ": {
        "name": "Mosambik"
    },
    "MM": {
        "name": "Myanmar"
    },
    "NA": {
        "name": "Namibia"
    },
    "NR": {
        "name": "Nauru"
    },
    "NP": {
        "name": "Nepal"
    },
    "NZ": {
        "name": "Neuseeland"
    },
    "NI": {
        "name": "Nicaragua"
    },
    "NL": {
        "name": "Niederlande"
    },
    "NE": {
        "name": "Niger"
    },
    "NG": {
        "name": "Nigeria"
    },
    "MK": {
        "name": "Nordmazedonien"
    },
    "NO": {
        "name": "Norwegen"
    },
    "OM": {
        "name": "Oman"
    },
    "AT": {
        "name": "Österreich"
    },
    "TL": {
        "name": "Osttimor"
    },
    "PK": {
        "name": "Pakistan"
    },
    "PW": {
        "name": "Palau"
    },
    "PA": {
        "name": "Panama"
    },
    "PG": {
        "name": "Papua-Neuguinea"
    },
    "PY": {
        "name": "Paraguay"
    },
    "PE": {
        "name": "Peru"
    },
    "PH": {
        "name": "Philippinen"
    },
    "PL": {
        "name": "Polen"
    },
    "PT": {
        "name": "Portugal"
    },
    "RW": {
        "name": "Ruanda"
    },
    "RO": {
        "name": "Rumänien"
    },
    "RU": {
        "name": "Russland"
    },
    "SB": {
        "name": "Salomonen"
    },
    "ZM": {
        "name": "Sambia"
    },
    "WS": {
        "name": "Samoa"
    },
    "SM": {
        "name": "San Marino"
    },
    "ST": {
        "name": "São Tomé und Príncipe"
    },
    "SA": {
        "name": "Saudi-Arabien"
    },
    "SE": {
        "name": "Schweden"
    },
    "CH": {
        "name": "Schweiz"
    },
    "SN": {
        "name": "Senegal"
    },
    "RS": {
        "name": "Serbien"
    },
    "SC": {
        "name": "Seychellen"
    },
    "SL": {
        "name": "Sierra Leone"
    },
    "ZW": {
        "name": "Simbabwe"
    },
    "SG": {
        "name": "Singapur"
    },
    "SK": {
        "name": "Slowakei"
    },
    "SI": {
        "name": "Slowenien"
    },
    "SO": {
        "name": "Somalia"
    },
    "ES": {
        "name": "Spanien"
    },
    "LK": {
        "name": "Sri Lanka"
    },
    "KN": {
        "name": "St. Kitts und Nevis"
    },
    "LC": {
        "name": "St. Lucia"
    },
    "VC": {
        "name": "St. Vincent und die Grenadinen"
    },
    "ZA": {
        "name": "Südafrika"
    },
    "SD": {
        "name": "Sudan"
    },
    "SS": {
        "name": "Südsudan"
    },
    "SR": {
        "name": "Suriname"
    },
    "SY": {
        "name": "Syrien"
    },
    "TJ": {
        "name": "Tadschikistan"
    },
    "TZ": {
        "name": "Tansania"
    },
    "TH": {
        "name": "Thailand"
    },
    "TG": {
        "name": "Togo"
    },
    "TO": {
        "name": "Tonga"
    },
    "TT": {
        "name": "Trinidad und Tobago"
    },
    "TD": {
        "name": "Tschad"
    },
    "CZ": {
        "name": "Tschechien"
    },
    "TN": {
        "name": "Tunesien"
    },
    "TR": {
        "name": "Türkei"
    },
    "TM": {
        "name": "Turkmenistan"
    },
    "TV": {
        "name": "Tuvalu"
    },
    "UG": {
        "name": "Uganda"
    },
    "UA": {
        "name": "Ukraine"
    },
    "HU": {
        "name": "Ungarn"
    },
    "UY": {
        "name": "Uruguay"
    },
    "UZ": {
        "name": "Usbekistan"
    },
    "VU": {
        "name": "Vanuatu"
    },
    "VE": {
        "name": "Venezuela"
    },
    "AE": {
        "name": "Vereinigte Arabische Emirate"
    },
    "US": {
        "name": "Vereinigte Staaten"
    },
    "GB": {
        "name": "Vereinigtes Königreich"
    },
    "VN": {
        "name": "Vietnam"
    },
    "CF": {
        "name": "Zentral­afrikanische Republik"
    },
    "CY": {
        "name": "Zypern"
    }
}